export default {
  namespaced: true,
  state: {
    recentItems: (() => {
      try {
        const saved = localStorage.getItem("swarajya_erp_recent_history");
        return saved ? JSON.parse(saved) : [];
      } catch (e) {
        return [];
      }
    })(),
  },
  getters: {
    recentItems: (state) => state.recentItems,
  },
  mutations: {
    ADD_VISITED_ITEM(state, item) {
      // Find duplicate paths
      const index = state.recentItems.findIndex((x) => x.path === item.path);
      if (index > -1) {
        // Remove existing duplicate to move it to top
        state.recentItems.splice(index, 1);
      }
      
      // Add to beginning
      state.recentItems.unshift({
        name: item.name,
        path: item.path,
        icon: item.icon || "LayoutDashboard",
        type: item.type || "page",
        timestamp: Date.now(),
      });

      // Cap at 10 items
      if (state.recentItems.length > 10) {
        state.recentItems = state.recentItems.slice(0, 10);
      }

      // Persist to local storage
      try {
        localStorage.setItem("swarajya_erp_recent_history", JSON.stringify(state.recentItems));
      } catch (e) {
        console.error("Failed to save history:", e);
      }
    },
    CLEAR_HISTORY(state) {
      state.recentItems = [];
      try {
        localStorage.removeItem("swarajya_erp_recent_history");
      } catch (e) {
        console.error("Failed to clear history:", e);
      }
    }
  },
  actions: {
    addVisit({ commit }, item) {
      commit("ADD_VISITED_ITEM", item);
    },
    clearHistory({ commit }) {
      commit("CLEAR_HISTORY");
    }
  },
};
